import { HomeIcon, ShieldExclamationIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';

import { Button } from '@/shared';
export const AccessDeniedCard = () => {
	return (
		<div className="flex flex-grow items-center justify-center">
			<div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-6 shadow-md">
				<div className="flex flex-col items-center justify-center gap-4 text-center">
					<div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
						<ShieldExclamationIcon className="h-10 w-10 text-red-500" />
					</div>

					<h2 className="text-xl font-bold text-gray-900">Доступ запрещен</h2>

					<div className="space-y-2 text-gray-600">
						<p>У вас нет доступа к этой странице.</p>
						<p>Обратитесь к администратору для получения прав доступа.</p>
					</div>

					<Link href="/" className="mt-2">
						<Button className="flex items-center gap-2" variant="green">
							<HomeIcon className="h-5 w-5" />
							На главную
						</Button>
					</Link>
				</div>
			</div>
		</div>
	);
};
